<template>
    <q-page padding>

        <q-dialog v-model="dialogMastertag" persistent>
            <q-card style="width: 850px; max-width: 90vw">
                <q-toolbar class="bg-primary text-white">
                    <q-toolbar-title class="text-h6"> Scripts Mastertag V3 </q-toolbar-title>
                    <q-btn flat round dense icon="mdi-close" aria-label="Fechar" @click="dialogMastertag = false" />
                </q-toolbar>

                <q-card-section class="q-pa-md">
                    <div class="text-body1 q-mb-md">
                        <q-icon name="mdi-information" color="primary" class="q-mr-sm" />
                        {{ $t('text_modal_generate_mastertag') }}
                    </div>
                    <q-select
                        v-if="isBetCampaign"
                        v-model="form.mastertag_host_type"
                        :options="mastertagHostTypeOptions"
                        emit-value
                        map-options
                        outlined
                        dense
                        class="q-mb-sm"
                        :label="$t('mastertag_domain')"
                    />
                    <div class="text-caption text-grey-8 q-mb-md">{{ mastertagScriptBaseUrl }}</div>
                    <div v-if="campaignSelect && campaignSelect.id" class="q-mt-md">
                        <q-toggle
                            :value="campaignSriAllowed"
                            :disable="campaignSriLoading"
                            :label="$t('mastertag_sri_campaign_toggle')"
                            @input="onCampaignSriToggle"
                        />
                        <div class="text-caption text-grey-7 q-mt-xs">{{ $t('mastertag_sri_campaign_hint') }}</div>
                    </div>
                </q-card-section>

                <q-separator />

                <q-card-section class="q-pa-none">
                    <q-list class="rounded-borders" separator>
                        <!-- Homepage -->
                        <q-item class="q-py-md">
                            <q-item-section>
                                <q-item-label class="text-subtitle1 text-weight-bold">
                                    <q-icon name="mdi-home" color="primary" class="q-mr-sm" />
                                    Homepage
                                </q-item-label>
                                <q-item-label class="q-mt-sm">
                                    <div class="bg-grey-2 q-pa-sm rounded-borders">
                                        <pre class="q-ma-none"
                                            style="font-family: 'Roboto Mono', monospace; font-size: 0.85rem">
&lt;script type="text/javascript" src="{{ mastertagScriptBaseUrl }}/v3/{{
    campaignSelect ? campaignSelect.id : ''
}}/homepage"&gt;&lt;/script&gt;</pre>
                                    </div>
                                </q-item-label>
                            </q-item-section>
                            <q-item-section side>
                                <q-btn flat round icon="mdi-content-copy" color="primary"
                                    @click="copyScriptToClipboard('homepage')">
                                    <q-tooltip>{{ $t('copy') }}</q-tooltip>
                                </q-btn>
                            </q-item-section>
                        </q-item>

                        <!-- Category -->
                        <q-item class="q-py-md">
                            <q-item-section>
                                <q-item-label class="text-subtitle1 text-weight-bold">
                                    <q-icon name="mdi-shape" color="primary" class="q-mr-sm" />
                                    Category
                                </q-item-label>
                                <q-item-label class="q-mt-sm">
                                    <div class="bg-grey-2 q-pa-sm rounded-borders">
                                        <pre class="q-ma-none"
                                            style="font-family: 'Roboto Mono', monospace; font-size: 0.85rem">
&lt;script type="text/javascript" src="{{ mastertagScriptBaseUrl }}/v3/{{
    campaignSelect ? campaignSelect.id : ''
}}/category"&gt;&lt;/script&gt;</pre>
                                    </div>
                                </q-item-label>
                            </q-item-section>
                            <q-item-section side>
                                <q-btn flat round icon="mdi-content-copy" color="primary"
                                    @click="copyScriptToClipboard('category')">
                                    <q-tooltip>{{ $t('copy') }}</q-tooltip>
                                </q-btn>
                            </q-item-section>
                        </q-item>

                        <!-- Product -->
                        <q-item class="q-py-md">
                            <q-item-section>
                                <q-item-label class="text-subtitle1 text-weight-bold">
                                    <q-icon name="mdi-package" color="primary" class="q-mr-sm" />
                                    Product
                                </q-item-label>
                                <q-item-label class="q-mt-sm">
                                    <div class="bg-grey-2 q-pa-sm rounded-borders">
                                        <pre class="q-ma-none"
                                            style="font-family: 'Roboto Mono', monospace; font-size: 0.85rem">
&lt;script type="text/javascript" src="{{ mastertagScriptBaseUrl }}/v3/{{
    campaignSelect ? campaignSelect.id : ''
}}/product"&gt;&lt;/script&gt;</pre>
                                    </div>
                                </q-item-label>
                            </q-item-section>
                            <q-item-section side>
                                <q-btn flat round icon="mdi-content-copy" color="primary"
                                    @click="copyScriptToClipboard('product')">
                                    <q-tooltip>{{ $t('copy') }}</q-tooltip>
                                </q-btn>
                            </q-item-section>
                        </q-item>

                        <!-- Basket -->
                        <q-item class="q-py-md">
                            <q-item-section>
                                <q-item-label class="text-subtitle1 text-weight-bold">
                                    <q-icon name="mdi-cart" color="primary" class="q-mr-sm" />
                                    Basket
                                </q-item-label>
                                <q-item-label class="q-mt-sm">
                                    <div class="bg-grey-2 q-pa-sm rounded-borders">
                                        <pre class="q-ma-none"
                                            style="font-family: 'Roboto Mono', monospace; font-size: 0.85rem">
&lt;script type="text/javascript" src="{{ mastertagScriptBaseUrl }}/v3/{{
    campaignSelect ? campaignSelect.id : ''
}}/basket"&gt;&lt;/script&gt;</pre>
                                    </div>
                                </q-item-label>
                            </q-item-section>
                            <q-item-section side>
                                <q-btn flat round icon="mdi-content-copy" color="primary"
                                    @click="copyScriptToClipboard('basket')">
                                    <q-tooltip>{{ $t('copy') }}</q-tooltip>
                                </q-btn>
                            </q-item-section>
                        </q-item>

                        <!-- Transaction -->
                        <q-item class="q-py-md">
                            <q-item-section>
                                <q-item-label class="text-subtitle1 text-weight-bold">
                                    <q-icon name="mdi-credit-card-check" color="primary" class="q-mr-sm" />
                                    Transaction
                                </q-item-label>
                                <q-item-label class="q-mt-sm">
                                    <div class="bg-grey-2 q-pa-sm rounded-borders">
                                        <pre class="q-ma-none"
                                            style="font-family: 'Roboto Mono', monospace; font-size: 0.85rem">
&lt;script type="text/javascript" src="{{ mastertagScriptBaseUrl }}/v3/{{
    campaignSelect ? campaignSelect.id : ''
}}/transaction"&gt;&lt;/script&gt;</pre>
                                    </div>
                                </q-item-label>
                            </q-item-section>
                            <q-item-section side>
                                <q-btn flat round icon="mdi-content-copy" color="primary"
                                    @click="copyScriptToClipboard('transaction')">
                                    <q-tooltip>{{ $t('copy') }}</q-tooltip>
                                </q-btn>
                            </q-item-section>
                        </q-item>
                    </q-list>
                </q-card-section>

                <q-separator />

                <q-card-actions align="right" class="q-pa-md">
                    <q-btn flat :label="$t('copy_all')" no-caps class="q-px-lg" color="secondary"
                        icon="mdi-content-copy" @click="copyAllToClipboard" />
                    <q-btn outline :label="$t('close')" no-caps class="q-px-lg" color="primary"
                        @click="dialogMastertag = false" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-toolbar class="column">
            <q-toolbar-title class="text-h5 q-mr-auto q-ma-sm"> {{ $t('edit') }} {{ $t('campaigns') }}
            </q-toolbar-title>
            <q-breadcrumbs class="q-mr-auto q-ma-sm">
                <q-breadcrumbs-el :label="$t('dashboard')" to="/ " />
                <q-breadcrumbs-el :label="$t('campaigns')" to="/campaigns" />
                <q-breadcrumbs-el :label="$t('edit_campaign')" exact />
            </q-breadcrumbs>
        </q-toolbar>
        <q-separator spaced />

        <q-toolbar class="q-pr-none q-mb-md">
            <q-space />
            <q-btn color="primary" no-caps icon="mdi-arrow-left" label="Voltar" unelevated to="/campaigns" />
            <!-- @click="onClose" -->
        </q-toolbar>

        <q-form @submit="onEditCampaign">
            <q-card bordered flat>
                <q-tabs v-model="tab" class="text-dark" active-color="primary" indicator-color="primary" align="justify"
                    inline-label mobile-arrows>
                    <q-route-tab name="detalhamento" :label="$t('details_2')"
                        :to="`/campaigns/edit/detalhamento/${id}`" />
                    <q-route-tab name="faturamento" :label="$t('billing')" :to="`/campaigns/edit/faturamento/${id}`" />
                    <q-route-tab name="comissao_full" :label="$t('commission_full')"
                        :to="`/campaigns/edit/comissao_full/${id}`" />
                    <q-route-tab name="historico" :label="$t('history')" :to="`/campaigns/edit/historico/${id}`" />
                    <q-route-tab name="cupons" :label="$t('coupons')" :to="`/campaigns/edit/cupons/${id}`" />
                    <!-- <q-route-tab
            name="comissao_full_diferenciada"
            label="Comissão Full Diferenciada"
            :to="`/campaigns/edit/comissao_full_diferenciada/${id}`"
          /> -->
                    <q-route-tab name="grupo_comissao" :label="$t('group_commission')"
                        :to="`/campaigns/edit/grupo_comissao/${id}`" />
                    <q-route-tab name="comissao_canais" :label="$t('commission_channels')"
                        :to="`/campaigns/edit/comissao_canais/${id}`" />
                    <q-route-tab name="agendamento_comissao" :label="$t('scheduling')"
                        :to="`/campaigns/edit/agendamento_comissao/${id}`" />
                    <q-route-tab name="aprovacao_canais" :label="$t('channel_approval')"
                        :to="`/campaigns/edit/aprovacao_canais/${id}`" />
                    <q-route-tab name="controle" :label="$t('control')" :to="`/campaigns/edit/controle/${id}`" />
                    <q-route-tab name="deeplink" label="Deeplink" :to="`/campaigns/edit/deeplink/${id}`" />
                </q-tabs>

                <q-separator />

                <q-tab-panels v-model="tab">
                    <q-tab-panel name="detalhamento">
                        <!-- <div class="text-h6">Detalhamento</div> -->

                        <q-card flat class="q-mt-md">
                            <q-card-section class="row items-center">
                                <q-card flat>
                                    <q-card-section class="row q-col-gutter-md q-pa-none">
                                        <div class="col-12">
                                            <span class="text-weight-medium">Status</span>
                                            <div class="q-gutter-sm">
                                                <q-checkbox v-model="form.is_test" val="4" :label="$t('test_campaign')"
                                                    color="purple" />
                                            </div>
                                        </div>
                                        <div class="col-3">
                                            <q-select v-model="form.advertiser_id" :options="advertisers"
                                                option-label="trademark" outlined clear-icon="mdi-close" clearable
                                                option-value="id" label="Advertiser*" lazy-rules :rules="[
                                                    (val) => {
                                                        if (!val) {
                                                            this.notifyRequiredOnce($t('advertiser_field_required'));
                                                            return $t('required_field');
                                                        }
                                                        return true;
                                                    }
                                                ]" readonly disable />
                                        </div>

                                        <div class="col-3">
                                            <q-select v-model="form.agency_id" :options="agenciesFiltered" use-input
                                                input-debounce="200" @filter="filterAgencies" option-label="trademark"
                                                outlined clear-icon="mdi-close" clearable option-value="id"
                                                :label="$t('agency')" lazy-rules />
                                        </div>

                                        <div class="col-1">
                                            <q-input v-model="form.cj_id" outlined label="CJ ID" maxlength="20"
                                                type="number" />
                                        </div>
                                        <div class="col-1">
                                            <q-input v-model="form.v2_id" outlined label="V2 ID" maxlength="20"
                                                type="number">
                                                <template>
                                                    <q-tooltip anchor="top middle" self="center middle"
                                                        content-class="bg-secondary text-white"
                                                        content-style="font-size: 12px">
                                                        ID {{ $t('campaign') }} V2
                                                    </q-tooltip>
                                                </template>
                                            </q-input>
                                        </div>
                                        <div class="col-4">
                                            <q-select v-model="form.comercial_manager_id" use-input input-debounce="200"
                                                @filter="filterComercialManager" :options="comercial_managersFiltered"
                                                req option-label="name" outlined clear-icon="mdi-close" clearable
                                                option-value="user_id" :label="$t('comercial_manager')" lazy-rules
                                                :rules="[
                                                    (val) => {
                                                        if (!val) {
                                                            this.notifyRequiredOnce($t('commercial_manager_field_required'));
                                                            return $t('required_field');
                                                        }
                                                        return true;
                                                    }
                                                ]" />
                                        </div>

                                        <div class="col-6">
                                            <!-- <span class="text-weight-medium">Nome da Campanha*</span> -->
                                            <q-input outlined v-model="form.name" type="text"
                                                :label="$t('campaign_name') + '*'" lazy-rules :rules="[
                                                    (val) => {
                                                        if (!val) {
                                                            this.notifyRequiredOnce($t('campaign_name_field_required'));
                                                            return $t('required_field');
                                                        }
                                                        return true;
                                                    }
                                                ]" />
                                        </div>

                                        <div class="col-6">
                                            <!-- <span class="text-weight-medium">Nome da Campanha*</span> -->
                                            <q-input outlined v-model="form.campaign_description" autogrow
                                                :label="$t('campaign_description') + '*'" lazy-rules :rules="[
                                                    (val) => {
                                                        if (!val) {
                                                            this.notifyRequiredOnce($t('campaign_description_field_required'));
                                                            return $t('required_field');
                                                        }
                                                        return true;
                                                    }
                                                ]" />
                                        </div>

                                        <div class="col-6">
                                            <q-card flat bordered class="q-mb-lg">
                                                <q-card-section class="text-center">
                                                    <q-btn icon="mdi-close" v-if="logo_url || form.logo_url" unelevated
                                                        class="q-ma-md absolute-top-right" style="z-index: 1" dense
                                                        rounded color="primary" @click="removeLogo()">
                                                    </q-btn>

                                                    <q-img class="col-12 q-mb-md" v-if="logo_url" :src="logo_url"
                                                        style="width: 360px; height: 200px" contain />
                                                    <q-img class="col-12 q-mb-md" v-else-if="previewLogoUrl"
                                                        :src="previewLogoUrl" style="width: 360px; height: 200px"
                                                        contain />

                                                    <q-avatar v-else square class="full-width q-mb-md"
                                                        style="height: 200px" font-size="100px"
                                                        :color="!$q.dark.isActive ? 'grey-3' : 'dark'"
                                                        :text-color="!$q.dark.isActive ? 'grey-5' : 'white'"
                                                        icon="mdi-file-image" />

                                                    <q-file :label="'Logo ' + $t('of_3') + ' ' + $t('campaign')"
                                                        accept=".jpg,.jpeg,.png,.gif" outlined @input="onChangeImage"
                                                        v-model="form.logo_url">
                                                        <template v-slot:append>
                                                            <q-avatar>
                                                                <q-icon name="mdi-pencil" color="primary" />
                                                            </q-avatar>
                                                        </template>
                                                    </q-file>
                                                </q-card-section>
                                            </q-card>
                                        </div>

                                        <div class="col-6 q-col-gutter-y-sm">
                                            <div class="row q-col-gutter-sm">
                                                <div class="col-4">
                                                    <q-select v-model="form.url.protocol"
                                                        :options="['https://', 'http://']" label="Protocolo URL*"
                                                        outlined clearable clear-icon="mdi-close" lazy-rules :rules="[
                                                            (val) => {
                                                                if (!val) {
                                                                    this.notifyRequiredOnce(`PROTOCOLO URL ${$t('required_field')}`);
                                                                    return $t('required_field');
                                                                }
                                                                return true;
                                                            }
                                                        ]" />
                                                </div>
                                                <div class="col-8">
                                                    <q-input outlined type="text" label="URL*" v-model="form.url.link"
                                                        lazy-rules :rules="[
                                                            (val) => {
                                                                if (!val) {
                                                                    this.notifyRequiredOnce(`URL ${$t('required_field')}`);
                                                                    return $t('required_field');
                                                                }
                                                                return true;
                                                            }
                                                        ]" />
                                                </div>
                                            </div>
                                            <div class="row q-col-gutter-sm">
                                                <div class="col-4">
                                                    <q-select v-model="form.category_id" :options="categories"
                                                        option-label="name" outlined clear-icon="mdi-close" clearable
                                                        option-value="id" :label="$t('category')" lazy-rules :rules="[
                                                            (val) => {
                                                                if (!val) {
                                                                    this.notifyRequiredOnce(`${$t('category')} ${$t('required_field')}`);
                                                                    return $t('required_field');
                                                                }
                                                                return true;
                                                            }
                                                        ]" />
                                                </div>
                                                <div class="col-4">
                                                    <q-select v-model="form.segmentation" :options="segmentations"
                                                        option-label="description" option-value="id" outlined
                                                        clear-icon="mdi-close" map-options clearable
                                                        :label="$t('segmentation')" :rules="[isRequired]" />
                                                </div>
                                                <div class="row col-4 q-pb-lg">
                                                    <q-checkbox v-model="form.is_exclusive" val="4"
                                                        :label="$t('exclusive_campaign')" color="purple" />
                                                </div>
                                            </div>
                                            <div class="row q-col-gutter-sm q-mb-md">
                                                <div class="col-6">
                                                    <date-input :v-model="form.activation_date" outlined
                                                        :label="$t('start_date') + '*'"
                                                        @update="form.activation_date = $event" />
                                                </div>
                                                <!-- @update="(value) => (form.activation_date = value)" -->

                                                <div class="col-6">
                                                    <date-input :v-model="form.expiration_date" outlined
                                                        :label="$t('end_date')"
                                                        @update="form.expiration_date = $event" />
                                                </div>
                                            </div>
                                            <div class="row q-col-gutter-sm">
                                                <div class="col-4">
                                                    <q-select v-model="form.budget_currency" :options="currencyOptions"
                                                        emit-value map-options label="Budget*" outlined clearable
                                                        clear-icon="mdi-close" lazy-rules :rules="[
                                                            (val) => {
                                                                if (!val) {
                                                                    this.notifyRequiredOnce(`BUDGET ${$t('required_field')}`);
                                                                    return $t('required_field');
                                                                }
                                                                return true;
                                                            }
                                                        ]" />
                                                </div>
                                                <div class="col-8">
                                                    <q-input outlined type="number" :label="$t('unlimited_value')"
                                                        v-model="form.budget_amount" />
                                                </div>
                                            </div>
                                        </div>
                                    </q-card-section>
                                </q-card>

                                <q-card flat>
                                    <q-separator spaced="xl" />
                                    <q-card-section class="row q-mt-md q-col-gutter-md q-pa-none">
                                        <div class="col-6">
                                            <div class="row q-col-gutter-sm">
                                                <div class="col-6">
                                                    <q-input outlined type="number" :label="$t('cookie_time') + '*'"
                                                        v-model="form.cookie_time" lazy-rules :rules="[
                                                            (val) => {
                                                                if (!val) {
                                                                    this.notifyRequiredOnce(`${$t('cookie_time')} ${$t('required_field')}`);
                                                                    return $t('required_field');
                                                                }
                                                                return true;
                                                            }
                                                        ]" />
                                                </div>
                                                <div class="col-6">
                                                    <q-select v-model="form.cookie_time_metric" :options="[
                                                        { label: $t('minutes'), value: 'minutos' },
                                                        { label: $t('hours'), value: 'horas' },
                                                        { label: $t('days'), value: 'dias' }
                                                    ]" :label="$t('period') + '*'" outlined clearable
                                                        clear-icon="mdi-close" ref="cookie_time_metric" lazy-rules
                                                        :rules="[
                                                            (val) => {
                                                                if (!val) {
                                                                    this.notifyRequiredOnce(`${$t('period')} ${$t('required_field')}`);
                                                                    return $t('required_field');
                                                                }
                                                                return true;
                                                            }
                                                        ]" />
                                                </div>
                                            </div>
                                            <div class="q-mt-md">
                                                <q-card flat bordered>
                                                    <q-card-section>
                                                        <span class="text-weight-medium">{{ $t('attribution') }}*</span>
                                                        <q-select
                                                            class="q-mt-sm"
                                                            v-model="form.attribution_policy"
                                                            :options="attributionPolicyOptions"
                                                            :label="$t('attribution_policy')"
                                                            outlined
                                                            emit-value
                                                            map-options
                                                            :rules="[isRequired]"
                                                        />
                                                    </q-card-section>
                                                </q-card>
                                            </div>
                                        </div>

                                        <div class="col-6">
                                            <q-card flat bordered>
                                                <q-card-section>
                                                    <span class="text-weight-medium">{{ $t('allowed_formats') }}*</span>
                                                    <div class="q-gutter-sm">
                                                        <q-checkbox v-model="form.allowed_format_email_mkt" val="1"
                                                            label="E-mail Marketing" color="primary" />
                                                        <q-checkbox
                                                            v-model="form.allowed_format_coupon_cashback_website"
                                                            val="2" :label="$t('coupon_cashback_website')"
                                                            color="primary" />

                                                        <q-checkbox v-model="form.allowed_format_influencers" val="0"
                                                            :label="$t('influencers')" color="primary" />
                                                        <q-checkbox v-model="form.allowed_format_content" val="0"
                                                            :label="$t('content')" color="primary" />
                                                        <q-checkbox v-model="form.allowed_format_media_buying" val="0"
                                                            :label="$t('media_buying')" color="primary" />
                                                        <q-checkbox v-model="form.allowed_format_subnets" val="0"
                                                            :label="$t('subnets')" color="primary" />
                                                        <q-checkbox v-model="form.allowed_format_technologies" val="0"
                                                            :label="$t('technologies')" color="primary" />
                                                        <q-checkbox v-model="form.allowed_format_retargeting" val="0"
                                                            label="Retargeting" color="primary" />
                                                        <q-checkbox v-model="form.allowed_format_push_notification"
                                                            val="0" label="Push Notification" color="primary" />
                                                        <q-checkbox
                                                            v-model="form.allowed_format_social_media_pages_and_groups"
                                                            val="3" :label="$t('social_media_pages_and_groups')"
                                                            color="primary" />
                                                    </div>
                                                </q-card-section>
                                            </q-card>
                                        </div>
                                    </q-card-section>
                                </q-card>

                                <q-card class="col-12 q-my-lg" flat>
                                    <q-card-section class="q-pa-none">

                                        <div class="col-6 q-gutter-sm">
                                            <q-card flat bordered>
                                                <q-card-section>
                                                    <span class="text-weight-medium">{{ $t('integration_type')
                                                    }}*</span>
                                                    <div class="disabled-container"
                                                        :class="{ 'disabled-container': isDisabled }">
                                                        <q-radio v-model="integration_type" val="Pixel" label="Pixel"
                                                            color="primary" />
                                                        <q-radio v-model="integration_type" val="Postback"
                                                            label="Postback" color="primary" />
                                                        <q-radio v-model="integration_type" val="API" label="API"
                                                            color="primary" />
                                                        <q-radio v-model="integration_type" val="Mobile" label="Mobile"
                                                            color="primary" />
                                                        <q-radio v-model="integration_type" val="Outro"
                                                            :label="$t('other')" color="primary" />
                                                        <q-input v-if="isOther" v-model="otherIntegrationType"
                                                            :label="$t('add_information')" outlined dense
                                                            :readonly="isDisabled" />
                                                    </div>
                                                </q-card-section>
                                            </q-card>
                                        </div>
                                        <br />

                                        <div class="col-12 q-gutter-sm">
                                            <div class="row q-col-gutter-md">
                                                <div class="col-6">
                                                    <q-card flat bordered>
                                                        <q-card-section>
                                                            <span class="text-weight-medium">Mastertag*</span>
                                                            <div class="q-gutter-sm">
                                                                <p class="text">{{ $t('mastertag_question') }}</p>
                                                                <div class="row justify-between">
                                                                    <q-select class="col-9 q-pr-md"
                                                                        :options="[$t('yes'), $t('no'), $t('dont_know')]"
                                                                        outlined dense clearable clear-icon="mdi-close"
                                                                        v-model="mastertag" :readonly="isDisabled" />
                                                                    <q-btn dense no-caps class="col-3" color="primary"
                                                                        :label="$t('generate_mastertag')"
                                                                        @click="dialogMastertag = true" />
                                                                </div>
                                                                <q-select
                                                                    v-if="isBetCampaign"
                                                                    v-model="form.mastertag_host_type"
                                                                    :options="mastertagHostTypeOptions"
                                                                    emit-value
                                                                    map-options
                                                                    outlined
                                                                    dense
                                                                    class="q-mt-sm"
                                                                    :label="$t('mastertag_domain')"
                                                                />
                                                                <div class="text-caption text-grey-8 q-mt-xs">
                                                                    {{ mastertagScriptBaseUrl }}
                                                                </div>
                                                            </div>
                                                        </q-card-section>
                                                    </q-card>
                                                </div>
                                                <div class="col-6">
                                                    <q-card flat bordered>
                                                        <q-card-section>
                                                            <span class="text-weight-medium">{{ $t('gtm_release')
                                                            }}*</span>
                                                            <div class="q-gutter-sm">
                                                                <p class="text">{{
                                                                    $t('gtm_release_question_edit_campaign') }}</p>
                                                                <q-select
                                                                    :options="[$t('team_afilio'), $t('client'), $t('dont_know')]"
                                                                    outlined dense clearable clear-icon="mdi-close"
                                                                    v-model="gtm_release" :readonly="isDisabled" />
                                                            </div>
                                                        </q-card-section>
                                                    </q-card>
                                                </div>
                                            </div>
                                        </div>
                                        <br />

                                        <div class="row q-col-gutter-md">
                                            <div class="col-12">
                                                <q-input outlined v-model="form.parameterized_url" autogrow
                                                    :label="$t('parameterized_url')"
                                                    :hint="$t('parameterized_url_hint')" :rules="[isValidUrl]" />
                                            </div>
                                        </div>
                                        <br />

                                        <div class="col-6 q-gutter-sm">
                                            <q-card flat bordered>
                                                <q-card-section>
                                                    <span class="text-weight-medium">{{ $t('test_method') }}*</span>
                                                    <div class="q-gutter-sm">
                                                        <p class="text">
                                                            {{ $t('test_method_question') }}
                                                        </p>
                                                        <div class="row q-col-gutter-md">
                                                            <div class="col-4">
                                                                <q-select v-model="test_method_real_data_registration"
                                                                    :options="[$t('yes'), $t('no'), $t('dont_know')]"
                                                                    :label="$t('real_data_registration')" outlined dense
                                                                    clearable clear-icon="mdi-close"
                                                                    :readonly="isDisabled" />
                                                            </div>

                                                            <div class="col-4">
                                                                <q-select v-model="test_method_no_invoice_purchase"
                                                                    :options="[$t('yes'), $t('no'), $t('dont_know')]"
                                                                    :label="$t('purchase_without_invoice')" outlined
                                                                    dense clearable clear-icon="mdi-close"
                                                                    :readonly="isDisabled" />
                                                            </div>

                                                            <div class="col-4">
                                                                <q-input outlined dense
                                                                    v-model="test_method_other_issues" autogrow
                                                                    :label="$t('others')" :readonly="isDisabled" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </q-card-section>
                                            </q-card>
                                        </div>
                                        <br />

                                        <div class="col-6 q-gutter-sm">
                                            <q-card flat bordered>
                                                <q-card-section>
                                                    <span class="text-weight-medium">{{ $t('proof_method') }}*</span>
                                                    <div class="q-gutter-sm">
                                                        <p class="text">
                                                            {{ $t('proof_method_question') }}
                                                        </p>
                                                        <div class="row q-col-gutter-md">
                                                            <div class="col-12">
                                                                <q-input outlined dense v-model="proof_method" autogrow
                                                                    :label="$t('add_information')"
                                                                    :readonly="isDisabled" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </q-card-section>
                                            </q-card>
                                        </div>

                                        <q-separator spaced="xl" />

                                        <q-toolbar class="bg-white text-dark q-px-none">
                                            <q-toolbar-title class="text-body1">
                                                {{ $t('implementation_contact') }}
                                            </q-toolbar-title>

                                            <q-btn @click="
                                                form.pixel_contacts.push({
                                                    id: form.pixel_contacts.length + 1,
                                                    name: null,
                                                    email: null,
                                                    phone: null,
                                                    appendParams: {}
                                                })
                                                " color="primary" icon="mdi-plus" no-caps unelevated>
                                                <q-tooltip> {{ $t('add_new_contact') }}</q-tooltip>
                                            </q-btn>
                                        </q-toolbar>

                                        <div class="row q-col-gutter-sm q-pa-none"
                                            v-for="(contact, index) in form.pixel_contacts" :key="contact.id">
                                            <div class="col-4">
                                                <q-input outlined type="text" :label="$t('name') + '*'" dense
                                                    v-model="contact.name" lazy-rules :rules="[
                                                        (val) => {
                                                            if (!val) {
                                                                notifyRequiredOnce($t('implementation_contact_name_required'));
                                                                return $t('required_field');
                                                            }
                                                            return true;
                                                        }
                                                    ]" />
                                            </div>

                                            <div class="col-4">
                                                <q-input outlined type="email" label="Email*" dense
                                                    v-model="contact.email" lazy-rules :rules="[
                                                        (val) =>
                                                            !!val ||
                                                            notifyRequiredOnce($t('implementation_contact_email_required')) ||
                                                            $t('required_field'),
                                                        (val) => {
                                                            const res = isEmail(val);
                                                            if (res !== true) {
                                                                notifyRequiredOnce($t('implementation_contact_email_valid'));
                                                                return res;
                                                            }
                                                            return true;
                                                        }
                                                    ]" />
                                            </div>

                                            <div class="col-4">
                                                <q-input outlined type="text" :label="$t('phone') + '*'" dense
                                                    v-model="contact.phone" mask="+## ## #####-####" unmasked-value
                                                    hint="Ex. +55 21 99999-9999" lazy-rules :rules="[
                                                        (val) => {
                                                            if (!val) {
                                                                notifyRequiredOnce($t('implementation_contact_phone_required'));
                                                                return $t('required_field');
                                                            }
                                                            return true;
                                                        }
                                                    ]">
                                                    <template v-if="index != 0" v-slot:after>
                                                        <q-btn @click="form.pixel_contacts.splice(index, 1)"
                                                            color="negative" icon="mdi-close" round dense unelevated>
                                                            <q-tooltip> {{ $t('remove_contact') }}</q-tooltip>
                                                        </q-btn>
                                                    </template>
                                                </q-input>
                                            </div>
                                        </div>

                                        <q-separator spaced="xl" />

                                        <div class="row q-col-gutter-md">
                                            <div class="col-3">
                                                <q-select v-model="billingModel" :options="[
                                                    { label: $t('contract'), value: 'contract' },
                                                    { label: 'PI', value: 'pi' }
                                                ]" :label="$t('billing_model') + '*'" outlined
                                                    lazy-rules :rules="[isRequired]" 
                                                    emit-value map-options />
                                            </div>

                                            <div class="col-9">
                                                <q-input outlined v-model="form.additional_informations" autogrow
                                                    :label="$t('additional_campaign_information')" />
                                            </div>
                                        </div>
                                    </q-card-section>
                                </q-card>
                            </q-card-section>
                            <q-separator inset />
                            <q-card-actions align="right" class="q-pa-md">
                                <q-btn unelevated :label="$t('save')" no-caps padding="sm lg" color="primary"
                                    type="submit" />
                            </q-card-actions>
                        </q-card>
                    </q-tab-panel>

                    <q-tab-panel name="faturamento">
                        <!-- <div class="text-h6">Faturamento</div>           -->
                        <CampaignBilling :id="id" class="q-pt-lg" />
                    </q-tab-panel>

                    <q-tab-panel name="comissao_full">
                        <ComssionFull :id="id" />
                    </q-tab-panel>

                    <q-tab-panel name="historico">
                        <Historic :campaign_id="id" />
                    </q-tab-panel>

                    <q-tab-panel name="cupons">
                        <CampaignCoupons :id="id" />
                    </q-tab-panel>

                    <!-- <q-tab-panel name="comissao_full_diferenciada">
            <CustomCommissionFull :id="id" />
          </q-tab-panel> -->
                    <q-tab-panel name="grupo_comissao">
                        <ComissionGroup :id="id" />
                    </q-tab-panel>
                    <q-tab-panel name="comissao_canais">
                        <ComissionChannel :id="id" />
                    </q-tab-panel>
                    <q-tab-panel name="agendamento_comissao">
                        <ComissionSchedule :id="id" />
                    </q-tab-panel>
                    <q-tab-panel name="aprovacao_canais">
                        <ChannelApproval :id="id" />
                    </q-tab-panel>
                    <q-tab-panel name="controle">
                        <!-- <div class="text-h6">Controle</div> -->
                        <Control :id="id" />
                    </q-tab-panel>
                    <q-tab-panel name="deeplink">
                        <div class="text-h6">Deeplink</div>
                        <Deeplink :id="id" />
                    </q-tab-panel>
                </q-tab-panels>
            </q-card>
        </q-form>
    </q-page>
</template>

<script>
import CampaignMixin from '../../mixins/CampaignMixin';
import DateInput from '../../widgets/inputsGlobal/DateInput.vue';
import CampaignBilling from './CampaignBilling.vue';
import ComssionFull from './ComssionFull.vue';
import ConversorPhpService from '../../services/ConversorPhpService';
import MastertagService, {
    MASTERTAG_HOST_BCONNECT,
    MASTERTAG_HOST_BETCONNECT,
    SEGMENTATION_BET,
    mastertagPublicScriptHost,
    normalizeMastertagHostType
} from '../../services/MastertagService.js';
import { attributionPolicyOptions, ATTRIBUTION_POLICIES } from '../../constants/attributionPolicy';
// import CustomCommissionFull from "./CustomCommissionFull.vue";
import ComissionGroup from './ComissionGroup.vue';
import ComissionChannel from './ComissionChannel.vue';
import ComissionSchedule from './ComissionSchedule.vue';
import ChannelApproval from './ChannelApproval.vue';
import Control from './Control.vue';
import Deeplink from './Deeplink.vue';
import Historic from './EditCampaignTabs/HistoricTab.vue';
import CampaignCoupons from './CampaignCoupons.vue';

export default {
    components: {
        // SelectRequest,
        DateInput,
        CampaignBilling,
        ComssionFull,
        Historic,
        CampaignCoupons,
        // CustomCommissionFull,
        ComissionGroup,
        ComissionChannel,
        ComissionSchedule,
        ChannelApproval,
        Control,
        Deeplink
    },

    name: 'EditCampaign',

    mixins: [CampaignMixin, ConversorPhpService, MastertagService],

    props: {
        id: {
            type: [String, Number],
            require: true
        },
        tabCurrent: {
            type: String,
            default: 'detalhamento'
        }
    },

    data() {
        return {
            dialogMastertag: false,
            campaignSriAllowed: true,
            campaignSriLoading: false,
            campaignSriHydrating: false,
            tab: 'detalhamento',
            advertisers: [],
            agencies: [],
            categories: [],
            comercial_managers: [],
            comercial_managersFiltered: [],
            segmentations: [],
            agenciesFiltered: [],

            step: 'step1',
            isento: false,
            logo_url: null,
            previewLogoUrl: null,
            previousFormData: null,
            //   restriction_none: false,
            form: {
                is_test: false,
                is_exclusive: false,
                advertiser_id: null,
                agency_id: null,
                cj_id: null,
                v2_id: null,
                comercial_manager_id: null,
                name: null,
                campaign_description: null,
                url: {
                    protocol: null,
                    link: null
                },
                category_id: null,
                activation_date: null,
                expiration_date: null,
                budget_currency: null,
                budget_amount: null,
                cookie_time: null,
                cookie_time_metric: null,

                segmentation: null,
                mastertag_host_type: MASTERTAG_HOST_BETCONNECT,

                // atribuicao:
                attribution_policy: null,

                allowed_format_email_mkt: false,
                allowed_format_coupon_cashback_website: false,
                allowed_format_influencers: false,
                allowed_format_content: false,
                allowed_format_media_buying: false,
                allowed_format_subnets: false,
                allowed_format_technologies: false,
                allowed_format_retargeting: false,
                allowed_format_push_notification: false,
                allowed_format_social_media_pages_and_groups: false,

                contract: null,
                pi: null,
                // business_contact: [{ id: 1, name: null, email: null, phone: null, appendParams: {} }],
                pixel_contacts: [{ id: 1, name: null, email: null, phone: null, appendParams: {} }],
                comissions: [],
                additional_informations: null,
                parameterized_url: ''
            },
            indexComissionsArray: 0,
            //Campos informacionais
            integration_type: null,
            otherIntegrationType: null,
            mastertag: null,
            gtm_release: null,
            parameterized_url: null,
            test_method_real_data_registration: null,
            test_method_no_invoice_purchase: null,
            test_method_other_issues: null,
            proof_method: null,
            isOther: false,
            isDisabled: true,
            billingModel: null
        };
    },

    computed: {
        campaignSegmentationId() {
            const raw = this.form.segmentation ?? this.campaignSelect?.segmentation;
            if (raw == null || raw === '') return null;
            return typeof raw === 'object' ? raw.id : raw;
        },
        isBetCampaign() {
            return this.campaignSegmentationId === SEGMENTATION_BET;
        },
        mastertagHostTypeOptions() {
            return [
                { value: MASTERTAG_HOST_BETCONNECT, label: this.$t('mastertag_host_option_betting') },
                { value: MASTERTAG_HOST_BCONNECT, label: this.$t('mastertag_host_option_other') }
            ];
        },
        mastertagScriptBaseUrl() {
            return mastertagPublicScriptHost(this.campaignSegmentationId, this.form.mastertag_host_type);
        },
        attributionPolicyOptions() {
            return attributionPolicyOptions(this);
        }
    },

    methods: {
        copyScriptToClipboard(type) {
            // eslint-disable-next-line no-useless-escape
            const script = `<script type="text/javascript" src="${this.mastertagScriptBaseUrl}/v3/${this.campaignSelect.id}/${type}"><\/script>`;
            this.copyData(script);
        },

        copyAllToClipboard() {
            const scripts = ['homepage', 'category', 'product', 'basket', 'transaction']
                // eslint-disable-next-line no-useless-escape
                .map((type) => `<script type="text/javascript" src="${this.mastertagScriptBaseUrl}/v3/${this.campaignSelect.id}/${type}"><\/script>`)
                .join('\n\n');
            this.copyData(scripts);
        },

        parseCampaignSriAllowed(payload) {
            const body =
                payload && typeof payload === 'object' && payload.data != null && typeof payload.data === 'object'
                    ? payload.data
                    : payload;
            if (!body || body.sri_campaign_allowed === undefined || body.sri_campaign_allowed === null) {
                return true;
            }
            return body.sri_campaign_allowed === true || body.sri_campaign_allowed === 1;
        },

        async loadCampaignSriSetting() {
            if (!this.campaignSelect || !this.campaignSelect.id) {
                this.campaignSriAllowed = true;
                return;
            }
            this.campaignSriLoading = true;
            this.campaignSriHydrating = true;
            try {
                const response = await this.getCampaignSri(this.campaignSelect.id, this.campaignSegmentationId);
                this.campaignSriAllowed = this.parseCampaignSriAllowed(response.data);
            } catch (e) {
                this.campaignSriAllowed = true;
                this.errorNotify(e);
            } finally {
                this.campaignSriLoading = false;
                this.campaignSriHydrating = false;
            }
        },

        async onCampaignSriToggle(val) {
            if (this.campaignSriHydrating || !this.campaignSelect || !this.campaignSelect.id || this.campaignSriLoading) {
                return;
            }
            const previous = this.campaignSriAllowed;
            const next = !!val;
            this.campaignSriAllowed = next;
            this.campaignSriLoading = true;
            try {
                await this.putCampaignSri(this.campaignSelect.id, next, this.campaignSegmentationId);
                this.successNotify(this.$t('mastertag_sri_campaign_saved'));
            } catch (e) {
                this.campaignSriAllowed = previous;
                this.errorNotify(e);
            } finally {
                this.campaignSriLoading = false;
            }
        },

        notifyRequiredOnce: (() => {
            let timeout = null;
            return function (msg) {
                if (timeout) return;
                this.errorNotify(msg);
                timeout = setTimeout(() => {
                    timeout = null;
                }, 800);
            };
        })(),

        async uploadLogoCampaign(image) {
            try {
                this.onLoading(true);

                let form = new FormData();
                form.append('image', image);
                form.append('bucket', 's3AdvertiserLogos');

                const { data, status } = await this.$http.post('/v2/upload/campaign-logo', form, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if (status === 200) return data.image_upload.image_url;
            } catch (error) {
                if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
                else this.errorNotify(error);
            } finally {
                this.onLoading(false);
            }
        },

        removeLogo() {
            this.logo_url = null;
            this.form.logo_url = null;
            this.previewLogoUrl = null;
        },

        onChangeImage(value) {
            this.logo_url = null;
            this.previewLogoUrl = URL.createObjectURL(value);
            this.form.logo_url = value;
        },

        async setupPage() {
            this.onLoading(true);

            Promise.all([
                await this.getAdvertisers(),
                await this.getAgencies(),
                await this.getCategories(),
                await this.getComercialManagers(),
                await this.getCampaignById(this.id),
                await this.getSegmentations()
            ]);

            this.onLoading(false);
        },

        async getCampaignById(idCampaign) {
            if (idCampaign) {
                try {
                    const { data, status } = await this.getCampaignDetails(idCampaign);
                    if (status === 200) {
                        this.ActionSetCampaignSelect(data);
                        this.setValuesCampaign();
                    }
                } catch (error) {
                    if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
                    else this.errorNotify(error);
                }
            }
        },

        async getAdvertisers() {
            try {
                const { data, status } = await this.$http.get(
                    '/redirect?app=ADVERTISER&path=/api/get/advertiser/bytype/anunciante'
                );
                if (status === 200) this.advertisers = data;
            } catch (error) {
                if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
                else this.errorNotify(error);
            }
        },

        async getAgencies() {
            try {
                const { data, status } = await this.$http.get(
                    '/redirect?app=ADVERTISER&path=/api/get/advertiser/bytype/agencia'
                );
                if (status === 200) this.agencies = data;
                this.agenciesFiltered = data;
            } catch (error) {
                if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
                else this.errorNotify(error);
            }
        },

        async getCategories() {
            try {
                const { data, status } = await this.listCampaignsCategories();
                if (status === 200) {
                    data.sort((a, b) => a.name.localeCompare(b.name));
                    this.categories = data;
                }
            } catch (error) {
                if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
                else this.errorNotify(error);
            }
        },

        async getSegmentations() {
            try {
                const { data, status } = await this.getSegmentationsList();
                if (status === 200) {
                    this.segmentations = data;
                }
            } catch (error) {
                if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
                else this.errorNotify(error);
            }
        },

        async getComercialManagers() {
            try {
                let dataOrder = [];
                const { data, status } = await this.$http.get('/user/user-unblocked-by-profile/1,2');
                if (status === 200) {
                    dataOrder = data.sort((a, b) => {
                        if (a.name < b.name) return -1;
                        if (a.name > b.name) return 1;

                        return 0;
                    });
                    this.comercial_managers = dataOrder;
                    //this.comercial_managersFiltered = data;
                }
            } catch (error) {
                if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
                else this.errorNotify(error);
            }
        },

        filterComercialManager(val, update) {
            update(this.defaultFilter(val, 'comercial_managersFiltered', this.comercial_managers, 'name'));
        },

        filterAgencies(val, update) {
            update(this.defaultFilter(val, 'agenciesFiltered', this.agencies, 'trademark'));
        },

        setValuesCampaign() {
            if (this.campaignSelect) {
                this.form.is_test = this.campaignSelect.is_test == 1 ? true : false;
                this.form.is_exclusive = this.campaignSelect.is_exclusive == 1 ? true : false;
                this.form.advertiser_id = this.advertisers.find((item) => item.id == this.campaignSelect.advertiser_id);
                this.form.agency_id = this.agencies.find((item) => item.id == this.campaignSelect.agency_id);
                this.form.category_id = this.categories.find((item) => item.id == this.campaignSelect.category_id);
                this.form.comercial_manager_id = this.comercial_managers.find(
                    (item) => item.user_id == this.campaignSelect.comercial_manager_id
                );

                this.form.cj_id = this.campaignSelect.cj_id;
                this.form.v2_id = this.campaignSelect.v2_id;
                this.form.name = this.campaignSelect.name;
                this.form.campaign_description = this.campaignSelect.campaign_description;
                this.form.url.protocol = this.campaignSelect.url.split('//')[0].concat('//');
                this.form.url.link = this.campaignSelect.url.split('//')[1];
                this.logo_url = this.campaignSelect.logo_url;
                this.form.activation_date = this.campaignSelect.activation_date;
                this.form.expiration_date = this.campaignSelect.expiration_date;
                this.form.budget_currency = this.campaignSelect.budget_currency;
                this.form.budget_amount = this.campaignSelect.budget_amount;
                this.form.cookie_time = this.campaignSelect.cookie_time;
                this.form.parameterized_url = this.campaignSelect.parameterized_url;
                this.form.cookie_time_metric = this.campaignSelect.cookie_time_metric;

                // Contacts
                // this.form.business_contact = this.campaignSelect.contact.filter((item) => item.type == 'business');
                this.form.pixel_contacts = this.campaignSelect.contact.filter((item) => item.type == 'pixel');

                // Atribuitions
                this.form.attribution_policy = this.campaignSelect.attribution_policy || ATTRIBUTION_POLICIES.LAST_TOUCH;

                this.form.contract = this.campaignSelect.contract ? 'sim' : 'nao';
                this.form.pi = this.campaignSelect.pi ? 'sim' : 'nao';
                this.billingModel = this.campaignSelect.contract ? 'contract' : this.campaignSelect.pi ? 'pi' : null;
                this.form.segmentation = this.campaignSelect.segmentation;
                this.form.mastertag_host_type = normalizeMastertagHostType(
                    this.campaignSelect.mastertag_host_type
                );
                this.form.additional_informations = this.campaignSelect.additional_informations;

                // Allowed formats
                if (this.campaignSelect.allowed_formats) {
                    const formats = this.campaignSelect.allowed_formats.map((f) => f.name);
                    this.form.allowed_format_email_mkt = formats.includes('email_mkt');
                    this.form.allowed_format_coupon_cashback_website = formats.includes('coupon_cashback_website');
                    this.form.allowed_format_influencers = formats.includes('influencers');
                    this.form.allowed_format_content = formats.includes('content');
                    this.form.allowed_format_media_buying = formats.includes('media_buying');
                    this.form.allowed_format_subnets = formats.includes('subnets');
                    this.form.allowed_format_technologies = formats.includes('technologies');
                    this.form.allowed_format_retargeting = formats.includes('retargeting');
                    this.form.allowed_format_push_notification = formats.includes('push_notification');
                    this.form.allowed_format_social_media_pages_and_groups = formats.includes('social_media_pages_and_groups');
                }

                const noneSelected = !['Pixel', 'Postback', 'API', 'Mobile'].includes(this.campaignSelect.integration_type);

                if (noneSelected) {
                    this.$nextTick(() => {
                        this.integration_type = 'Outro';
                    });
                    this.isOther = true;
                    this.otherIntegrationType = this.campaignSelect.integration_type;
                }

                // Campos informacionais
                this.integration_type = this.campaignSelect.integration_type;
                this.mastertag = this.campaignSelect.mastertag;
                this.gtm_release = this.campaignSelect.gtm_release;
                // this.parameterized_url = this.campaignSelect.parameterized_url;
                this.test_method_real_data_registration = this.campaignSelect.test_method_real_data_registration;
                this.test_method_no_invoice_purchase = this.campaignSelect.test_method_no_invoice_purchase;
                this.test_method_other_issues = this.campaignSelect.test_method_other_issues;
                this.proof_method = this.campaignSelect.proof_method;
            }

            this.previousFormData = JSON.stringify(this.form);
        },

        async onEditCampaign() {
            // Comparação feita para verificar se houve alteração nos dados do detalhamento de campanhas
            if (this.previousFormData == JSON.stringify(this.form)) {
                this.errorNotify(this.$t('no_changes_detected'));
                return;
            }

            let formData = this.form;
            //   let contactAggregate = formData.business_contact.concat(formData.pixel_contacts);
            let commercialManagerId = formData.comercial_manager_id.user_id;
            let cookie_time_metric = formData.cookie_time_metric.value;
            let advertiser_id = formData.advertiser_id.id;
            let agency_id = formData.agency_id ? formData.agency_id.id : null;
            let pixel_contacts = JSON.stringify(formData.pixel_contacts);
            formData.is_test = formData.is_test ? 1 : 0;
            formData.is_exclusive = formData.is_exclusive ? 1 : 0;

            //   delete formData.business_contact;
            delete formData.pixel_contacts;
            delete formData.comissions;
            delete formData.cookie_time_metric;
            delete formData.last_click;
            delete formData.assisted;
            delete formData.direct;
            delete formData.organic;

            let data = {
                ...formData,
                url: `${this.form.url.protocol}${this.form.url.link}`,
                logo_url: false,
                category_id: this.form.category_id.id,
                segmentation: this.form.segmentation.id,
                mastertag_host_type: this.isBetCampaign
                    ? normalizeMastertagHostType(this.form.mastertag_host_type)
                    : null,
                comercial_manager_id: commercialManagerId,
                contact: pixel_contacts,
                cookie_time_metric: cookie_time_metric,
                advertiser_id: advertiser_id,
                agency_id: agency_id,
                v2_id: this.form.v2_id,
                contract: this.form.contract,
                pi: this.form.pi
            };

            if (!this.logo_url && this.previewLogoUrl) data.logo_url = await this.uploadLogoCampaign(this.form.logo_url);
            if (this.logo_url && !this.previewLogoUrl) delete data.logo_url;

            this.updateCampaign(data);
        },

        async updateCampaign(campaignData) {
            try {
                this.onLoading(true);
                const { status } = await this.editCampaignDetalhamento(this.id, campaignData);
                if (status === 200 || status === 201) {
                    await this.getCampaignById(this.id);

                    this.successNotify(this.$t('campaign_updated_successfully'));
                }
            } catch (error) {
                if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
                else this.errorNotify(error);
            } finally {
                this.onLoading(false);
            }
        },

        isValidUrl(val) {
            /* eslint-disable */
            const regex =
                /((https?|ftp)\:\/\/)?([a-z0-9+!*(),;?&=\$_.-]+(\:[a-z0-9+!*(),;?&=\$_.-]+)?@)?([:\/\a-z0-9-.]*)\.([a-z]{2,5})(\:[0-9]{2,5})?(\/([a-z0-9+\$_-]\.?)+)*\/?(\?[a-z+&\$_.-][a-z0-9!;:@&%=+\/\$_.-\|-]*)?(#[a-z_.-][a-z0-9+\$_.-]*)?/gm;
            /* eslint-enable */

            // if (!regex.test(val)) {
            //   return 'Url é inválida!';
            // }
            // return true;

            return regex.test(val) || val == '' || val == null || 'URL é inválida!';
        }
    },

    created() {
        this.setupPage();
    },

    watch: {
        dialogMastertag(open) {
            if (open) {
                this.$nextTick(() => this.loadCampaignSriSetting());
            }
        },
        tabCurrent() {
            if (this.tabCurrent == 'detalhamento') this.setValuesCampaign();
        },
        billingModel(value) {
            this.form.contract = value === 'contract' ? 'sim' : 'nao';
            this.form.pi = value === 'pi' ? 'sim' : 'nao';
        },
        campaignSegmentationId(segmentationId) {
            if (segmentationId === SEGMENTATION_BET) {
                if (!this.form.mastertag_host_type) {
                    this.form.mastertag_host_type = MASTERTAG_HOST_BETCONNECT;
                }
                return;
            }

            this.form.mastertag_host_type = null;
        }
    }
};
</script>

<style>
i.q-tabs__arrow {
    padding-top: 10px;
}

.disabled-container {
    pointer-events: none;
    opacity: 1.2;
}
</style>
